import "../useTreeItemIndex"
import { CurrentClientChanged, SidebarTreeRoots } from "event-definitions"
import noop from "lib/noop"

CurrentClientChanged.after.handleOnce(() => SidebarTreeRoots.raiseAsync({ add: noop }))
